import { useEffect, useState, useRef } from 'react';

const useStickyDetect = (offset = 0) => {
  const [isSticky, setIsSticky] = useState(false);
  const observer = useRef(null);
  const targetRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: `-${offset + 1}px 0px 0px 0px`,
      threshold: 1,
    };

    observer.current = new IntersectionObserver(([entry]) => setIsSticky(entry.intersectionRatio < 1), options);

    if (targetRef.current) {
      observer.current.observe(targetRef.current);
    }

    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, [targetRef, offset]);

  return { targetRef, isSticky };
};

export default useStickyDetect;
